import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { Card, Col, Form, Row } from 'antd';
import React from 'react';
import InfoCreate from '../components/InfoCreate';
import '../../../../../styles/pages/warehouse/_settlement/create-bill.scss';
import '../../../../../styles/abstracts/_variables.scss';

const Breadcrumb = [
  {
    tittle: 'Settlement',
    url: ''
  },
  {
    tittle: 'Billing Inquiry',
    url: ''
  },
  {
    tittle: 'Create Billing Inquiry',
    url: ''
  }
];

const CreateBilling = () => {
  return (
    <div>
      <BreadcrumbList listBreadcrumb={Breadcrumb} />
      <div className="admin-container ">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <div className="createBilling">
            <InfoCreate />
          </div>
        </Card>
      </div>
    </div>
  );
};

export default CreateBilling;
